/**
 * Fonction pour calculer l'avancée ajustée avec tous les ajouts selon les finitions
 * @param {Object} params - Paramètres de calcul
 * @returns {Object} - { avanceeAjustee, details }
 */
export const calculateAvanceeAjustee = (params) => {
  const {
    avanceeBase,
    avancee2 = null,
    isLambrequinSeul,
    isDoublePente,
    fixationHaute,
    fixationBasse,
    diametreJoncHaute,
    diametreJoncBasse,
    diametreFourreauBasse,
    joncMedianPosition,
    lambrequin,
    hauteurLambrequin,
    fixationLambrequin,
    diametreJoncLambrequin,
    optionsSupp,
    lestageDetails
  } = params;

  const details = [];
  let avanceeAjustee = 0;

  // CAS SPÉCIAL : Lambrequin seul
  if (isLambrequinSeul) {
    details.push({ label: 'Hauteur du lambrequin', valeur: avanceeBase });
    avanceeAjustee = avanceeBase;

    // Équerrage (toujours)
    avanceeAjustee += 5;
    details.push({ label: 'Équerrage', valeur: 5 });

    // Fixation du lambrequin
    if (fixationLambrequin === 'jonc') {
      avanceeAjustee += 5;
      details.push({ label: `Fixation lambrequin (Jonc ${diametreJoncLambrequin}mm)`, valeur: 5 });
    } else if (fixationLambrequin === 'agrafe') {
      avanceeAjustee += 3;
      details.push({ label: 'Fixation lambrequin (Agrafé - ourlet)', valeur: 3 });
    } else if (fixationLambrequin === 'ourlet') {
      avanceeAjustee += 3;
      details.push({ label: 'Fixation lambrequin (Ourlet)', valeur: 3 });
    }

    // Ourlet bas du lambrequin
    if (lambrequin === 'droit') {
      avanceeAjustee += 3;
      details.push({ label: 'Ourlet bas lambrequin (coupe droite)', valeur: 3 });
    } else if (lambrequin === 'ondule' || lambrequin === 'vagues') {
      details.push({ label: 'Ourlet bas lambrequin (vague - pas d\'ourlet)', valeur: 0 });
    }

    // Lestage du lambrequin (uniquement pour coupe droite)
    if (lambrequin === 'droit' && optionsSupp?.oeillets && lestageDetails?.diametreTube) {
      const diametreCm = lestageDetails.diametreTube / 10;
      const ajoutLestage = diametreCm * 4;
      avanceeAjustee += ajoutLestage;
      details.push({ label: `Lestage lambrequin (tube ${lestageDetails.diametreTube}mm = ${diametreCm}cm)`, valeur: ajoutLestage });
    }

    details.push({ label: 'TOTAL AVANCÉE AJUSTÉE', valeur: avanceeAjustee, isTotal: true });
    return { avanceeAjustee, details };
  }

  // CAS SPÉCIAL : Double Pente
  if (isDoublePente && avancee2 !== null) {
    details.push({ label: 'Avancée 1 (projection 1)', valeur: avanceeBase });
    avanceeAjustee += avanceeBase;

    details.push({ label: 'Avancée 2 (projection 2)', valeur: avancee2 });
    avanceeAjustee += avancee2;

    // Jonc médian
    if (joncMedianPosition) {
      avanceeAjustee += 5;
      details.push({ label: 'Jonc médian', valeur: 5 });
    }

    // Équerrage (toujours)
    avanceeAjustee += 5;
    details.push({ label: 'Équerrage', valeur: 5 });

    // Fixation haute (une seule fois, c'est le haut commun)
    if (fixationHaute === 'jonc') {
      avanceeAjustee += 5;
      details.push({ label: `Fixation haute (Jonc ${diametreJoncHaute}mm)`, valeur: 5 });
    } else if (fixationHaute === 'ourlet') {
      avanceeAjustee += 3;
      details.push({ label: 'Fixation haute (Ourlet)', valeur: 3 });
    } else if (fixationHaute === 'finition-brute') {
      details.push({ label: 'Fixation haute (Finition brute)', valeur: 0 });
    }

    // Fixation basse DEUX FOIS (une pour chaque pente)
    if (fixationBasse === 'jonc') {
      avanceeAjustee += 5;
      details.push({ label: `Fixation basse avancée 1 (Jonc ${diametreJoncBasse}mm)`, valeur: 5 });
      avanceeAjustee += 5;
      details.push({ label: `Fixation basse avancée 2 (Jonc ${diametreJoncBasse}mm)`, valeur: 5 });
    } else if (fixationBasse === 'fourreau') {
      const diametreCm = diametreFourreauBasse / 10;
      const ajoutFourreau = diametreCm * 4;
      avanceeAjustee += ajoutFourreau;
      details.push({ label: `Fixation basse avancée 1 (Fourreau ${diametreFourreauBasse}mm = ${diametreCm}cm)`, valeur: ajoutFourreau });
      avanceeAjustee += ajoutFourreau;
      details.push({ label: `Fixation basse avancée 2 (Fourreau ${diametreFourreauBasse}mm = ${diametreCm}cm)`, valeur: ajoutFourreau });
    }
  } else {
    // CAS NORMAL : Store simple ou autres
    details.push({ label: 'Avancée de base (projection)', valeur: avanceeBase });
    avanceeAjustee = avanceeBase;

    // Équerrage (toujours)
    avanceeAjustee += 5;
    details.push({ label: 'Équerrage', valeur: 5 });

    // Fixation haute
    if (fixationHaute === 'jonc') {
      avanceeAjustee += 5;
      details.push({ label: `Fixation haute (Jonc ${diametreJoncHaute}mm)`, valeur: 5 });
    } else if (fixationHaute === 'ourlet') {
      avanceeAjustee += 3;
      details.push({ label: 'Fixation haute (Ourlet)', valeur: 3 });
    } else if (fixationHaute === 'finition-brute') {
      details.push({ label: 'Fixation haute (Finition brute)', valeur: 0 });
    }

    // Fixation basse
    if (fixationBasse === 'jonc') {
      avanceeAjustee += 5;
      details.push({ label: `Fixation basse (Jonc ${diametreJoncBasse}mm)`, valeur: 5 });
    } else if (fixationBasse === 'fourreau') {
      const diametreCm = diametreFourreauBasse / 10;
      const ajoutFourreau = diametreCm * 4;
      avanceeAjustee += ajoutFourreau;
      details.push({ label: `Fixation basse (Fourreau ${diametreFourreauBasse}mm = ${diametreCm}cm)`, valeur: ajoutFourreau });
    }
  }

  // Lambrequin(s)
  if (lambrequin !== 'sans' && lambrequin !== 'aucun') {
    const nombreLambrequins = isDoublePente ? 2 : 1;
    const suffixe = isDoublePente ? ' (×2 pour double pente)' : '';

    // Hauteur du lambrequin
    const hauteurTotal = parseFloat(hauteurLambrequin) * nombreLambrequins;
    avanceeAjustee += hauteurTotal;
    details.push({ label: `Hauteur du lambrequin${suffixe}`, valeur: hauteurTotal });

    // Fixation du lambrequin (indépendant)
    if (fixationLambrequin === 'jonc') {
      const ajoutFixation = 5 * nombreLambrequins;
      avanceeAjustee += ajoutFixation;
      details.push({ label: `Fixation lambrequin (Jonc ${diametreJoncLambrequin}mm)${suffixe}`, valeur: ajoutFixation });
    } else if (fixationLambrequin === 'agrafe') {
      const ajoutFixation = 3 * nombreLambrequins;
      avanceeAjustee += ajoutFixation;
      details.push({ label: `Fixation lambrequin (Agrafé - ourlet)${suffixe}`, valeur: ajoutFixation });
    } else if (fixationLambrequin === 'ourlet') {
      const ajoutFixation = 3 * nombreLambrequins;
      avanceeAjustee += ajoutFixation;
      details.push({ label: `Fixation lambrequin (Ourlet)${suffixe}`, valeur: ajoutFixation });
    }

    // Ourlet bas du lambrequin
    if (lambrequin === 'droit') {
      const ajoutOurlet = 3 * nombreLambrequins;
      avanceeAjustee += ajoutOurlet;
      details.push({ label: `Ourlet bas lambrequin (coupe droite)${suffixe}`, valeur: ajoutOurlet });
    } else if (lambrequin === 'ondule' || lambrequin === 'vagues') {
      details.push({ label: `Ourlet bas lambrequin (vague - pas d'ourlet)${suffixe}`, valeur: 0 });
    }

    // Lestage du lambrequin (uniquement pour coupe droite)
    if (lambrequin === 'droit' && optionsSupp?.oeillets && lestageDetails?.diametreTube) {
      const diametreCm = lestageDetails.diametreTube / 10;
      const ajoutLestage = (diametreCm * 4) * nombreLambrequins;
      avanceeAjustee += ajoutLestage;
      details.push({ label: `Lestage lambrequin (tube ${lestageDetails.diametreTube}mm = ${diametreCm}cm)${suffixe}`, valeur: ajoutLestage });
    }
  }

  details.push({ label: 'TOTAL AVANCÉE AJUSTÉE', valeur: avanceeAjustee, isTotal: true });

  return { avanceeAjustee, details };
};
